/*global qq */
qq.version = "5.13.0";
